var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, cloneElement } from 'react';
import classNames from 'classnames';
import { Icon } from '@sb1/ffe-icons-react';
import { texts } from './texts';
import { Collapse } from '@sb1/ffe-collapse-react';
/**
 * Base component for all four types of context messages.
 *
 * *Should never be used directly!*
 * Please use one of the four versions exported from this package.
 */
export var ContextMessage = function (_a) {
    var icon = _a.icon, headerText = _a.headerText, _b = _a.compact, compact = _b === void 0 ? false : _b, messageType = _a.messageType, _c = _a.style, style = _c === void 0 ? {} : _c, _d = _a.showCloseButton, showCloseButton = _d === void 0 ? false : _d, _e = _a.headerElement, headerElement = _e === void 0 ? 'h2' : _e, headerElementId = _a.headerElementId, contentElementId = _a.contentElementId, children = _a.children, className = _a.className, _f = _a.locale, locale = _f === void 0 ? 'nb' : _f, onColoredBg = _a.onColoredBg, onCloseRest = _a.onCloseRest, rest = __rest(_a, ["icon", "headerText", "compact", "messageType", "style", "showCloseButton", "headerElement", "headerElementId", "contentElementId", "children", "className", "locale", "onColoredBg", "onCloseRest"]);
    var _g = useState(true), isOpen = _g[0], setIsOpen = _g[1];
    var closeIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjAiPjxwYXRoIGQ9Ik00ODAtNDQyLjg0NyAzMDkuMDc2LTI3MS45MjRxLTguMzA3IDguMzA4LTE3Ljg4NCA4LTkuNTc2LS4zMDctMTguMjY4LTktOC42OTMtOC42OTItOC42OTMtMTguNTc2dDguNjkzLTE4LjU3Nkw0NDIuODQ3LTQ4MCAyNzEuOTI0LTY1MC45MjRxLTguMzA4LTguMzA3LTgtMTguMzg0LjMwNy0xMC4wNzYgOS0xOC43NjggOC42OTItOC42OTMgMTguNTc2LTguNjkzdDE4LjU3NiA4LjY5M0w0ODAtNTE3LjE1M2wxNzAuOTI0LTE3MC45MjNxOC4zMDctOC4zMDggMTguMzg0LTguNSAxMC4wNzYtLjE5MyAxOC43NjggOC41IDguNjkzIDguNjkyIDguNjkzIDE4LjU3NnQtOC42OTMgMTguNTc2TDUxNy4xNTMtNDgwbDE3MC45MjMgMTcwLjkyNHE4LjMwOCA4LjMwNyA4LjUgMTcuODg0LjE5MyA5LjU3Ni04LjUgMTguMjY4LTguNjkyIDguNjkzLTE4LjU3NiA4LjY5M3QtMTguNTc2LTguNjkzTDQ4MC00NDIuODQ3WiIvPjwvc3ZnPg==';
    return (React.createElement(Collapse, { isOpen: isOpen, onRest: onCloseRest },
        React.createElement("div", __assign({ className: classNames('ffe-context-message', "ffe-context-message--".concat(messageType), {
                'ffe-context-message--compact': compact,
                'ffe-context-message--coloredbg': onColoredBg,
            }, className) }, rest),
            React.createElement("div", { className: "ffe-context-message-content" },
                React.isValidElement(icon) && (React.createElement("div", { className: "ffe-context-message-content__icon" }, cloneElement(icon, __assign(__assign({}, icon.props), { className: classNames('ffe-context-message-content__icon-span', icon.props.className) })))),
                React.createElement("div", null,
                    headerText &&
                        React.createElement(headerElement, {
                            className: 'ffe-context-message-content__header',
                        }, headerText),
                    React.createElement("div", { className: "ffe-body-text" }, children))),
            showCloseButton && (React.createElement("button", { "aria-label": "".concat(texts[locale].close, " ").concat(headerText || ''), className: "ffe-context-message-content__close-button", onClick: function () { return setIsOpen(false); }, type: "button" },
                React.createElement(Icon, { fileUrl: closeIcon, size: "sm" }))))));
};
